import { ArraySchema, ISchema } from '@framework/validation';

export const RichTextAdvancedMetaKey = 'rte';

export function isRichTextSchema(schema: ISchema<any>) {
  return (
    schema instanceof ArraySchema &&
    schema.meta()?.[RichTextAdvancedMetaKey] === true
  );
}
